import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const TOKEN_KEY = "jnt_admin_token";

export const api = axios.create({ baseURL: API, timeout: 20000 });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem(TOKEN_KEY);
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (error) => {
    if (error?.response?.status === 401 && window.location.pathname.startsWith("/admin") && window.location.pathname !== "/admin/login") {
      localStorage.removeItem(TOKEN_KEY);
      window.location.href = "/admin/login";
    }
    return Promise.reject(error);
  }
);

export const getErrorMessage = (error, fallback = "Something went wrong. Please try again.") => {
  const detail = error?.response?.data?.detail;
  if (!detail) return error?.message || fallback;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((d) => d.msg || JSON.stringify(d)).join(", ");
  return fallback;
};

// Public fetchers
export const fetchSettings = () => api.get("/settings").then((r) => r.data);
export const fetchServices = () => api.get("/services").then((r) => r.data);
export const fetchService = (slug) => api.get(`/services/${slug}`).then((r) => r.data);
export const fetchProducts = () => api.get("/products").then((r) => r.data);
export const fetchProduct = (slug) => api.get(`/products/${slug}`).then((r) => r.data);
export const fetchIndustries = () => api.get("/industries").then((r) => r.data);
export const fetchTestimonials = () => api.get("/testimonials").then((r) => r.data);
export const fetchFaqs = () => api.get("/faqs").then((r) => r.data);
export const submitInquiry = (payload) => api.post("/inquiries", payload).then((r) => r.data);

// Admin
export const adminLogin = (payload) => api.post("/auth/login", payload).then((r) => r.data);
export const adminMe = () => api.get("/auth/me").then((r) => r.data);
export const adminDashboard = () => api.get("/admin/dashboard").then((r) => r.data);
export const adminList = (resource) => api.get(`/admin/${resource}`).then((r) => r.data);
export const adminCreate = (resource, payload) => api.post(`/admin/${resource}`, payload).then((r) => r.data);
export const adminUpdate = (resource, id, payload) => api.put(`/admin/${resource}/${id}`, payload).then((r) => r.data);
export const adminDelete = (resource, id) => api.delete(`/admin/${resource}/${id}`).then((r) => r.data);
export const adminInquiries = (params) => api.get("/admin/inquiries", { params }).then((r) => r.data);
export const adminInquiry = (id) => api.get(`/admin/inquiries/${id}`).then((r) => r.data);
export const adminPatchInquiry = (id, payload) => api.patch(`/admin/inquiries/${id}`, payload).then((r) => r.data);
export const adminDeleteInquiry = (id) => api.delete(`/admin/inquiries/${id}`).then((r) => r.data);
export const adminSettings = () => api.get("/admin/settings").then((r) => r.data);
export const adminUpdateSettings = (payload) => api.put("/admin/settings", payload).then((r) => r.data);
export const adminChangePassword = (payload) => api.post("/auth/change-password", payload).then((r) => r.data);
export const adminExportUrl = () => `${API}/admin/inquiries/export`;
